import * as types from './mutation-types'

export default {
  [types.ADD_MEDIA](state, data) {
    state.medias.push(data)
  },
  [types.LOAD_PAGES](state, data) {
    state.pages=data
  },
  [types.LOAD_SOCIAL_MEDIA](state, data) {
    state.social_media=data
  }
}
